export enum ProjectsDialog {
    NONE,
    SAVE,
    LOAD,
    DELETE
}
